import { RouterExitService } from './services/router-exit.service';
import { CaresIdsResolver } from './resolvers/cares-ids/cares-ids.resolver';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlHandlingStrategy, ExtraOptions } from '@angular/router';
import { Ng1Ng2UrlHandlingStrategy } from './ng1Ng2UrlHandlingStrategy';
import { ShelterIdResolver } from './resolvers/shelter-id/shelter-id.resolver';
import { ShelterNameResolver } from './resolvers/shelter-name/shelter-name.resolver';
import { routeHelpers } from './route-helpers/routes-helpers';

const routes: Routes = routeHelpers.get();

// DEBUGGING ROUTES? Set { enableTracing: true } below and check console
const options: ExtraOptions = {
  useHash: false,
  enableTracing: false,
  paramsInheritanceStrategy: 'always',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule],
  providers: [
    ShelterIdResolver,
    ShelterNameResolver,
    CaresIdsResolver,
    RouterExitService,
    { provide: UrlHandlingStrategy, useClass: Ng1Ng2UrlHandlingStrategy },
  ],
})
export class AppRoutingModule {
  // inject the service into the app routing module to activate service
  constructor(public exitService: RouterExitService) {}
}
